<script setup>

</script>

<template>
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.75 11H5.25" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
